<template>
  <div class="interface">
    <!-- 导航栏 -->
    <div class="subject">
      <div class="header"></div>
      <div class="main">
        <!-- 图片部分 -->
        <div class="image_part" v-if="!imageGeneration">
          <div class="image_collection">
            <!-- <div class="collection">☆收藏</div> -->
            <div></div>
            <div class="favorites" @click="favorites()">收藏夹>>></div>
          </div>
          <div class="image_background">
            <div>{{ text.prompt01 }}</div>
            <div class="image_background_text">{{ text.prompt02 }}</div>
          </div>
        </div>
        <div class="image_part" v-if="imageGeneration">
          <div class="image_collection">
            <div
              :class="['collection', { collected: isCollected }]"
              @click="showCollectible()"
            >
              {{ isCollected ? "★已收藏" : "☆收藏" }}
            </div>
            <div class="favorites" @click="favorites()">收藏夹>>></div>
          </div>
          <div class="image_display">
            <div class="image_display_prompt">点击图片进行编辑</div>
            <div class="image_display01" v-if="!imageQuantity">
              <img
                @click="nextStep(0)"
                class="image_ontology"
                :src="imageList[0].xthumbPath"
                alt=""
              />
              <img
                @click="nextStep(1)"
                class="image_ontology"
                :src="imageList[1].xthumbPath"
                alt=""
              />
            </div>
            <div class="image_display01" v-if="!imageQuantity">
              <img
                @click="nextStep(2)"
                class="image_ontology"
                :src="imageList[2].xthumbPath"
                alt=""
              />
              <img
                @click="nextStep(3)"
                class="image_ontology"
                :src="imageList[3].xthumbPath"
                alt=""
              />
            </div>
          </div>
        </div>
        <!-- 文字描述 -->
        <textarea
          v-model="text_to_image.prompt"
          placeholder="请输入您想要设计的卡面内容"
          class="textarea"
        ></textarea>
      </div>
      <div class="footer">
        <div class="left" @click="Previouspage()">←上一步</div>
        <div class="button" @click="applyNow()">
          生成图片
          <div class="frequency">次数（{{ frequency }}）</div>
        </div>
        <!-- <div class="nextstep" @click="nextStep()">下一步</div> -->
      </div>
    </div>
    <!-- 图片生成中 -->
    <div v-show="loading">
      <div class="weui-mask_transparent"></div>
      <div class="weui-toast">
        <i class="weui-loading weui-icon_toast"></i>
        <p class="weui-toast__content">{{ loadingInfo }}</p>
      </div>
    </div>
    <!-- 提示 -->
    <b-modal
      ok-only
      ref="model_error"
      title="提示"
      @ok="handleOk"
      ok-title="确定"
    >
      <p class="my-4">{{ errorMsg }}</p>
    </b-modal>
    <!-- 图片收藏 -->
    <b-modal
      ok-only
      ref="model_collectible"
      title="提示"
      @ok="collectibleOK"
      ok-title="确定"
    >
      <p class="my-4">是否收藏图片？</p>
    </b-modal>
  </div>
</template>
<script>
import axios from "axios";
const config = require("@/common/config");
const logUrl = require("@/common/logUrl");
export default {
  name: "AItext_to_image_ningbo",
  data() {
    return {
      logUrlList: logUrl.logUrl,
      process: 0, //文生图 0； 图文生图 1； 图生图 2；
      frequency: "", //生成次数

      text: {
        prompt01: "根据您输入的文字描述或关键词生成图片。",
        prompt02: "示例：帮我画一张油画风格的火烈鸟，夕阳下悠闲的在河边散步……",
      },
      imageGeneration: false, //图片是否生成
      imageList: [],
      text_to_image: {
        prompt: "", //提示词，
        size: "1024*768", //  输出图像的分辨率。默认值是1024*1024。图像宽高边长的像素范围为：[768, 1440]，单位像素。可任意组合以设置不同的图像分辨率，最高可达200万像素。
        bankSerialNumber: "", //银行流水号，
        num: 4, // 生成图片的数量。取值范围为1~4张，默认为4。
        phone: "", //手机号
      },
      taskId: "", //申请图片返回ID
      loading: false,
      loadingInfo: "",
      errorMsg: "",
      imagePath: "", //编辑图片地址
      imageQuantity: false,
      bankCode: "",
      selectParam: "",
      isCollected: false,
    };
  },
  methods: {
    Previouspage() {
      this.$router.push({
        name: "AISelectCardface_ningbo",
      });
    },
    // 收藏
    collection() {
      let params = {
        phone: this.text_to_image.phone,
        taskId: this.taskId,
      };
      console.log("collectible--->", params);
      axios.post(config.config_demo.collectible, params).then((res) => {
        console.log("collectible--->", res);
        if (res.data.code == 200) {
          this.isCollected = !this.isCollected;
        }
      });
    },
    showCollectible() {
      this.$refs["model_collectible"].show();
    },
    collectibleOK() {
      this.collection();
    },
    // 收藏夹
    favorites() {
      this.$router.replace({
        name: "AICollection_ningbo",
        params: {
          process: this.process,
          taskId: this.taskId,
          // phone: this.text_to_image.phone,
        },
      });
    },
    // 图片生成
    applyNow() {
      if (this.frequency <= 0) {
        this.errorMsg = "您的AI次数已用完，请您明天再来！";
        this.showErrorMsg();
      } else if (this.text_to_image.prompt == "") {
        this.errorMsg = "请您描述您的图片要素";
        this.showErrorMsg();
      } else {
        this.AItext_to_image();
      }
    },
    AItext_to_image() {
      let that = this;
      this.loadingInfo = "图片生成中...";
      this.showLoading();
      let param = {
        prompt: this.text_to_image.prompt,
        size: this.text_to_image.size,
        bankSerialNumber: this.text_to_image.bankSerialNumber,
        num: this.text_to_image.num,
        phone: this.text_to_image.phone,
      };
      console.log("AItext_to_image  param--->", param);
      axios
        .post(config.config_demo.AI_text_to_image, param)
        .then((res) => {
          console.log("AI_text_to_image--->", res);
          if (res.data.code == 200) {
            that.hideLoading();
            that.loadingInfo = "";
            that.imageList = res.data.data.result;
            that.taskId = res.data.data.taskId;
            // 将taskID保存
            localStorage.setItem("taskId", that.taskId);
            // 图片展示
            that.imageGeneration = true;
            // that.getFrequency();
            that.decrResidualNums();
          } else {
            that.errorMsg = "接口返回信息错误";
            that.showErrorMsg();
          }
        })
        .catch(function () {});
    },
    // 下一步
    nextStep(index) {
      this.loadingInfo = "编辑图片...";
      this.showLoading();
      this.pic2Base64(index);
    },
    // url转换成base64
    pic2Base64(index) {
      let param = {
        url: this.imageList[index].imagePath,
      };
      console.log("pic2Base64--->", param);
      axios
        .post(config.config_demo.pic2Base64, param)
        .then((res) => {
          console.log("pic2Base64--->", res);
          this.imagePath = res.data.data.base64;
          this.toEditCardface();
        })
        .catch();
    },
    toEditCardface() {
      this.hideLoading();
      this.loadingInfo = "";
      this.$router.replace({
        name: "AIEditCardface_ningbo",
        params: {
          imagePath: this.imagePath,
          process: this.process,
          taskId: this.taskId,
          phone: this.text_to_image.phone,
        },
      });
    },
    showLoading: function () {
      this.loading = true;
    },
    hideLoading: function () {
      this.loading = false;
    },
    showErrorMsg: function () {
      this.$refs["model_error"].show();
    },
    handleOk: function (bvModalEvt) {},
    // 查询
    getRecords() {
      let that = this;
      let params = {
        phone: this.text_to_image.phone,
        taskId: localStorage.getItem("taskId"),
        isSave: "",
      };
      console.log("getRecords--->", params);
      axios.post(config.config_demo.getRecords, params).then((res) => {
        console.log("getRecords--->", res);
        that.imageList = res.data.data;
        that.imageGeneration = true;
      });
    },
    // 查询次数
    getFrequency() {
      let phone = localStorage.getItem("phone_ningbo");
      axios
        .get(config.config_demo.initResidualNums + `/${phone}`)
        .then((res) => {
          console.log("initResidualNums--->", res);
          if (res.data.code == 200) {
            this.frequency = res.data.data.num;
          } else {
            console.log("getRecords错误");
          }
        });
    },
    // 减少次数
    decrResidualNums() {
      let phone = localStorage.getItem("phone_ningbo");
      axios
        .get(config.config_demo.decrResidualNums + `/${phone}`)
        .then((res) => {
          console.log("decrResidualNums--->", res);
          if (res.data.code == 200) {
            this.frequency = res.data.data.num;
          } else {
            console.log("getRecords错误");
          }
        });
    },
  },
  created() {
    this.getFrequency();
    // this.decrResidualNums();
  },
  mounted() {
    // phone
    this.text_to_image.phone = localStorage.getItem("phone_ningbo");
    const backoff = this.$route.params.backoff;
    if (backoff == 0) {
      // 正常流程
      // this.phone = this.$route.params.phone;
    } else if (backoff == 1) {
      // 回退流程
      this.taskId = this.$route.params.taskId;
      // this.text_to_image.phone = localStorage.getItem("phone");
      if (this.taskId == "") {
        // 正常流程
      } else {
        this.getRecords();
      }
    }
    this.text_to_image.bankSerialNumber = localStorage.getItem(
      "bankSerialNumber_ningbo"
    );
    console.log("bankSerialNumber:" + this.text_to_image.bankSerialNumber);
    this.bankCode = localStorage.getItem("bankCode");
    console.log("bankCode:" + this.bankCode);
  },
  beforeDestroy() {
    this.imageGeneration = false;
  },
};
</script>

<style scoped>
.navigation {
  position: fixed;
  z-index: 1000;
  width: 100%;
  background: linear-gradient(left, #3861d5, white);
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 0 2rem;
}
.home_img {
  width: 1.8rem;
}
.back {
  font-size: 1.2rem;
  font-weight: 700;
  color: white;
}
/* 页面主体内容 */
.subject {
  padding: 1.8rem 1rem 0;
  /* background-color: pink; */
  display: flex;
  flex-direction: column;
  justify-content: center;
}
/* .header {
  background-color: aqua;
  height: 3rem;
} */
.main {
  /* background-color: yellow; */
  width: 100%;
}
.image_part {
  width: 100%;
  height: 25rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.image_collection {
  width: 100%;
  height: 2rem;
  background-color: antiquewhite;
  border-radius: 0.4rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0 1.6rem;
}
.collection {
  font-size: 0.9rem;
  font-weight: 700;
}
.favorites {
  font-size: 0.9rem;
  font-weight: 700;
}
.image_background {
  width: 100%;
  height: 100%;
  background: url("../../../../static/demoImage/背景01.png") no-repeat center /
    cover;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  font-size: 1rem;
  font-weight: 700;
}
.image_background_text {
  padding-top: 1rem;
  font-size: 1rem;
  font-weight: 500;
  color: slategrey;
}
.image_display {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
}
.image_display01 {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 1rem 1rem;
  /* background-color: #3861d5; */
}
.image_ontology {
  width: 8rem;
  border-radius: 0.4rem;
}
.textarea {
  width: 100%;
  height: 5rem;
  border-radius: 1rem;
  text-align: center;
}
.image_display_prompt {
  font-weight: 700;
}
.footer {
  /* background-color: blue;
  height: 3rem; */
  padding-top: 3rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.button {
  color: white;
  /* background-color: #3861d5; */
  background: linear-gradient(to right, #093695, #0d1632);
  display: flex; /* 启用 Flex 布局 */
  align-items: center; /* 垂直居中 */
  justify-content: center;
  font-size: 0.8rem;
  border-radius: 1.2rem;
  width: 50%;
  height: 2.6rem;
}
.left {
  width: 40%;
  height: 2.6rem;
  border: 1px solid #023bb6;
  border-radius: 1.3rem;
  color: #023bb6;
  font-weight: 700;
  font-size: 1rem;
  text-align: center;
  padding-top: 0.4rem;
}
/* .nextstep {
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.8rem;
  border-radius: 1.2rem;
  width: 45%;
  height: 2.4rem;
  border: 1px solid black;
} */
.frequency {
  font-size: 0.6rem;
  margin-left: 0.3rem;
}
</style>



// WEBPACK FOOTER //
// src/components/ningboBus/AIGC/AItext_to_image.vue